<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="clients"
  [(selectedItems)]="_selectedClients"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="searchClient($event.filter)"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? selectLabel : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [display]="display"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  [sort]="sort"
  [placeholder]="placeholder"
  [scrollHeight]="scrollHeight"
  [loading]="selectionLoading"
  (openedChange)="openedChange.emit($event)">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
